if (!customElements.get('po-product-gallery-pagination')) {
    class PoProductGalleryPagination extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.closest('po-swiper');
            this.currentSlideEl = this.querySelector("[data-current-slide]");
            this.prevButton = this.swiper?.querySelector('[data-prev-button]');
            this.nextButton = this.swiper?.querySelector('[data-next-button]');

            if (!this.currentSlideEl) {
                console.error('po-product-gallery-pagination must contain an element with dataset "data-current-slide"');
                return;
            }

            if (!this.swiper) {
                console.error('po-product-gallery-pagination must be a child of op-swiper');
                return;
            }
        }

        connectedCallback() {
            const swiperInstance = this.swiper.swiper;
            if (!swiperInstance) return;

            const totalSlides = swiperInstance.slides.length;

            const updatePagination = (index) => {
                this.currentSlideEl.innerText = index + 1;

                if (this.prevButton) {
                    this.prevButton.classList.toggle('tw-text-po-disabled', index === 0);
                }

                if (this.nextButton) {
                    this.nextButton.classList.toggle('tw-text-po-disabled', index === totalSlides - 1);
                }
            };

            updatePagination(swiperInstance.activeIndex);

            this.swiper.addEventListener('slideChanged', (event) => {
                updatePagination(event.detail.activeIndex);
            });
        }
    }

    customElements.define("po-product-gallery-pagination", PoProductGalleryPagination);
}